<template>
	<!-- 通票展示组件：新增通票（完整数据）与编辑通票差异对比（仅变更字段）复用 -->
	<div>
		<div v-for="(ticket, idx) in tickets" :key="idx" class="through-ticket-item">
			<template v-if="ticket">
				<!-- 票名 + 票品id（用于定位） -->
				<div class="ticket-name">{{ticket.ticketName}}<span class="color-blue ML10" v-if="ticket.id">（票品id：{{ticket.id}}）</span></div>
				<ul>
					<!-- 类型：memberNum 1=单人 / >1=多人 -->
					<li v-if="hasField(ticket, 'memberNum')">
						<div>类型:</div>
						<span :class="changedClass(idx, 'memberNum')">{{ticket.memberNum == 1 ? '通票-单人票' : '通票-多人票'}}</span>
					</li>
					<!-- 绑定场次：sessionIds 为多场次 id 逗号串，翻译为场次名+开演时间 -->
					<li v-if="hasField(ticket, 'sessionIds')">
						<div>绑定场次:</div>
						<span :class="changedClass(idx, 'sessionIds')">{{sessionView(ticket.sessionIds)}}</span>
					</li>
					<li v-if="hasField(ticket, 'sellPrice')">
						<div>票品售价:</div>
						<span :class="changedClass(idx, 'sellPrice')">{{ticket.sellPrice}}元</span>
					</li>
					<li v-if="hasField(ticket, 'originalPrice')">
						<div>票品原价:</div>
						<span :class="changedClass(idx, 'originalPrice')">{{ticket.originalPrice}}元</span>
					</li>
					<!-- 限购：accountLimitNum 0=不限购 -->
					<li v-if="hasField(ticket, 'accountLimitNum')">
						<div>票品限购:</div>
						<span :class="changedClass(idx, 'accountLimitNum')">{{ticket.accountLimitNum == 0 ? '不限购' : `每账号限购${ticket.accountLimitNum}张`}}</span>
					</li>
					<!-- 销售状态：status 0 正常 1 暂停 -->
					<li v-if="hasField(ticket, 'status')">
						<div>销售状态:</div>
						<span :class="changedClass(idx, 'status')">{{sellStatus.get(ticket.status) || ''}}</span>
					</li>
					<li v-if="hasField(ticket, 'startTime')">
						<div>销售开始时间:</div>
						<span :class="changedClass(idx, 'startTime')">{{ticket.startTime}}</span>
					</li>
					<li v-if="hasField(ticket, 'endTime')">
						<div>销售结束时间:</div>
						<span :class="changedClass(idx, 'endTime')">{{ticket.endTime}}</span>
					</li>
					<li v-if="hasField(ticket, 'instruction')">
						<div>票品说明:</div>
						<span :class="changedClass(idx, 'instruction')">{{ticket.instruction}}</span>
					</li>
				</ul>
			</template>
			<span v-else>该通票已删除</span>
			<el-divider v-if="idx < tickets.length - 1"></el-divider>
		</div>
	</div>
</template>

<script>
import {activityStatus} from './mixins.js';
export default {
	mixins: [activityStatus],
	props: {
		// 通票列表（新增通票为完整数据，差异对比为仅变更字段的元素）
		tickets: {
			type: Array,
			default: () => []
		},
		// 详情内场次集合（用于 sessionIds 翻译为场次名+开演时间）
		sessions: {
			type: Array,
			default: () => []
		},
		// 对比的另一侧通票列表（传入后字段值变更将高亮）
		compareTickets: {
			type: Array,
			default: null
		}
	},
	computed: {
		// 场次 id → 场次信息映射（兼容 id / idStr 两种键）
		sessionMap() {
			const map = new Map();
			this.sessions.forEach(s => {
				if (!s) return;
				[s.id, s.idStr].forEach(k => {
					if (k !== undefined && k !== null && k !== '') map.set(String(k), s);
				});
			});
			return map;
		}
	},
	methods: {
		// 字段是否存在（0 与 false 视为有效值）
		hasField(ticket, key) {
			return ticket[key] !== undefined && ticket[key] !== null && ticket[key] !== '';
		},
		// 变更高亮：与对比列表同下标元素比较，值不一致则标红
		changedClass(idx, key) {
			if (!this.compareTickets || !this.compareTickets[idx] || !this.tickets[idx]) return '';
			return String(this.tickets[idx][key] ?? '') !== String(this.compareTickets[idx][key] ?? '') ? 'color-danger' : '';
		},
		// sessionIds（多场次 id 逗号串）翻译为「场次名（开演时间开演）」
		sessionView(sessionIds) {
			return String(sessionIds || '').split(',').filter(v => v !== '').map(id => {
				const s = this.sessionMap.get(String(id));
				if (s) {
					const name = s.sessionName || s.name || '';
					return s.startTime ? `${name}（${s.startTime}开演）` : (name || `场次ID:${id}`);
				}
				return `场次ID:${id}`;
			}).join('、');
		}
	}
}
</script>

<style lang="scss" scoped>
/* 通票条目样式 */
.through-ticket-item {
	margin-bottom: 10px;

	&:last-child {
		margin-bottom: 0;
	}

	.ticket-name {
		margin-bottom: 10px;
		font-weight: 600;
	}

	ul {
		li {
			display: flex;
			align-items: top;
			margin-bottom: 10px;

			div {
				margin-right: 10px;
				width: 100px;
				min-width: 100px;
				text-align: right;
				color: $--color-info;
			}

			&:nth-last-child(1) {
				margin: 0;
			}
		}
	}
}
</style>
